var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 2H7.99921C5.34881 2.0016 3.20001 4.2128 3.20001 6.9408C3.20001 9.6688 5.94081 12.5856 7.99761 13.9976V14L7.99841 13.9992L7.99921 14V13.9984C10.056 12.5864 12.7968 9.6688 12.7968 6.9416C12.7976 4.2128 10.6496 2.0016 8.00001 2ZM8.00001 9.2C6.67441 9.2 5.60001 8.1256 5.60001 6.8C5.60001 5.4744 6.67441 4.4 8.00001 4.4C9.32561 4.4 10.4 5.4744 10.4 6.8C10.4 8.1256 9.32561 9.2 8.00001 9.2Z",
    fill: "#FF3049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.ee84a3b284c1ca84518818ac848dee7e.svg";
export { ForwardRef as ReactComponent };